import * as React from 'react';

import WorkSummaryBillingType from 'ab-enums/workSummaryBillingType.enum';

import { Button } from '@acceligentllc/storybook';

import Checkbox from 'af-components/Controls/Checkbox';
import CustomModal from 'af-components/CustomModal';

import styles from '../styles.module.scss';

const CHECKBOX_LABEL = 'Don\'t show this message again';

interface OwnProps {
	showModal: boolean;
	closeModal: () => void;
	onSubmit: (showMessageAgain: boolean) => void;
	billingType: WorkSummaryBillingType;
}

type Props = OwnProps;

const BulkEditBillableStatusModal: React.FC<Props> = (props) => {
	const { closeModal, showModal, onSubmit, billingType } = props;

	const [showMessageAgain, setShowMessageAgain] = React.useState(false);

	const isMaterialExpense = React.useMemo(() => billingType === WorkSummaryBillingType.MATERIAL_COST, [billingType]);

	const title = React.useMemo(() => isMaterialExpense
		? 'Bulk Edit Material Expense Status?'
		: 'Bulk Edit Billable Status?', [isMaterialExpense]);

	const body = React.useMemo(() => isMaterialExpense
		? 'This action will change material expense status of all material expense associated with this row. Any grouping and splitting may be lost and may need to be redone manually. Continue?'
		: 'This action will change billable status of all billable work associated with this row. Any grouping and splitting may be lost and may need to be redone manually. Continue?',
		[isMaterialExpense]);

	// If modal closed reset checkbox
	React.useEffect(() => {
		if (!showModal && showMessageAgain) {
			setShowMessageAgain(false);
		}
	}, [showMessageAgain, showModal]);

	const handleShowMessageAgain = React.useCallback(() => {
		setShowMessageAgain(!showMessageAgain);
	}, [showMessageAgain]);

	const handleConfirmation = React.useCallback(() => {
		onSubmit(showMessageAgain);
		closeModal();
	}, [closeModal, onSubmit, showMessageAgain]);

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="warning"
			showModal={showModal}
			size="md"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title={title}
			/>
			<CustomModal.Body>
				{body}
			</CustomModal.Body>
			<CustomModal.Footer className={styles['bulk-edit-billable-status-modal__footer']}>
				<Checkbox
					handleChange={handleShowMessageAgain}
					isChecked={showMessageAgain}
					isStandalone={true}
					label={CHECKBOX_LABEL}
				/>
				<div className={styles['bulk-edit-billable-status-modal__btn-container']}>
					<Button
						label="Cancel"
						onClick={closeModal}
						style="secondary"
					/>
					<Button
						label="Continue"
						onClick={handleConfirmation}
						style="primary"
					/>
				</div>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(BulkEditBillableStatusModal);
